const AppConstant = {
    apiEndPoint: process.env.REACT_APP_API_END_POINT || 'http://sso_server:3012/graphql',
};

export default AppConstant;
